import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FilterResponseModel } from '../models/filter/filter-response.model';

@Injectable({
  providedIn: 'root'
})

export class GlobalService {

  @Output() renderRibbon: EventEmitter<number> = new EventEmitter();

  authCode: any;
  loggedInUser;
  subscription: string;
  environment: string;
  tagMovMsg;
  constructor( public httpClient: HttpClient, public dialog: MatDialog) { }
  isAuthorize: boolean = false;
  isActivate: boolean = true;
  /* URL's for APIMS screen */
  customFunctionURL: string = "https://management.azure.com/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.ApiManagement/service/r4cidi-apim-we-d/apis/custom-component/operations";
  /* URL for model Management screen */
  modelListULR: string = "https://westeurope.modelmanagement.azureml.net/modelmanagement/v1.0/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.MachineLearningServices/workspaces/comm-mlrepo-we-d/models";
  deleteModelURL: string = "https://westeurope.modelmanagement.azureml.net/modelmanagement/v1.0/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.MachineLearningServices/workspaces/comm-mlrepo-we-d/models/";
  assetUrl = "https://westeurope.modelmanagement.azureml.net/modelmanagement/v1.0/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.MachineLearningServices/workspaces/comm-mlrepo-we-d/assets";
  registerModelURL = "https://westeurope.modelmanagement.azureml.net/modelmanagement/v1.0/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.MachineLearningServices/workspaces/comm-mlrepo-we-d/models";

  monitoringComponentName = "Monitoring";

  userDetails: any;
  firstTimeLoad: boolean = true;

  gethttpHeader(bearerToken) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Methods': 'POST, GET',
        'Authorization': 'Bearer ' + bearerToken
      })
    };
    return httpOptions;
  }

  showAlert(model, data) {
     this.dialog.open(model, {
      width: '450px',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: data
    });
  }

  showAlertWithCallBack(model, data, methodRef: (thisRef: any, result?: any) => void, thisRef) {
    const dialogRef = this.dialog.open(model, {
      width: '450px',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result && result != null){
        methodRef(thisRef);
      }
    });
  }

  openModelWindowWithoutCallBack(modelComponent, widthOfWindow, panelClassName, dataToPass) {
    {
       this.dialog.open(modelComponent, {
        width: widthOfWindow,
        panelClass: panelClassName,
        height: 'auto',
        data: dataToPass,
        disableClose: true
      });
    }
  }

  openModelWindow(methodRef: (thisRef: any, result?: any) => void, thisRef, modelComponent, widthOfWindow, panelClassName, dataToPass, functionality?) {
    {
      const dialogRef = this.dialog.open(modelComponent, {
        width: widthOfWindow,
        panelClass: panelClassName,
        data: dataToPass,
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result === true && methodRef != null 
          || result !== false
          || result === false && methodRef != null && functionality === "statusChange") {
          methodRef(thisRef, result);
        }
      });
    }
  }

  /**
   * Checks if the given string parameter is not undefined, null or empty.
   * @param data string to be checked
   */
  isNotNull(data: string) {
    let response: boolean = false;
    if (data != undefined && data != null && data != "") {
      response = true;
    }
    return response;
  }

  /**
   * Checks if the given object is not undefined or null.
   * @param data string to be checked
   */
  isNotNullObject(data) {
    let response: boolean = false;
    if (data != undefined && data != null) {
      response = true;
    }
    return response;
  }


  /**
   * Replaces display text for filter
   * @param tempText
   */
  replaceDisplayText(tempText: string) {
    let displayText: string = "";
    if (tempText == "workflowName") {
      displayText = "Workflow Name";
    } else if (tempText == "workflowDescription") {
      displayText = "Description";
    } else if (tempText == "workflowId") {
      displayText = "Workflow Id";
    } else if (tempText == "lastRun") {
      displayText = "Last Run";
    } else if (tempText == "lastRunStatus") {
      displayText = "Last Run Status";
    } else if (tempText == "lastUpdatedBy") {
      displayText = "Last Modified By";
    } else {
      displayText = tempText;
    }
    return displayText;
  }

  /**
 * Replaces custom display text for filter
 * @param tempText
 */
  replaceCustomDisplayText(tempText: string) {
    let displayText: string = "";
    if (tempText == "componentName") {
      displayText = "Name";
    } else if (tempText == "businessDescription") {
      displayText = "Description";
    }else if (tempText == "createdBy") {
      displayText = "created By";
    } else {
      displayText = tempText;
    }
    return displayText;
  }

  /**
   * Replace filter texts
   * @param tempText
   */
  replaceFilterText(tempText: string): string {
    if (tempText == "Workflow Name") {
      return "workflowName";
    } else if (tempText == "Description") {
      return "workflowDescription";
    } else if (tempText == "Workflow Id") {
      return "workflowId";
    } else if (tempText == "Last Run") {
      return "lastRun";
    } else if (tempText == "Last Run Status") {
      return "lastRunStatus";
    }  else if (tempText == "Last Modified By") {
      return "lastUpdatedBy";
    } else {
      return tempText;
    }
  }  /**
  * Replace custom filter texts
  * @param tempText
  */
 replaceCustomFilterText(tempText: string): string {
   if (tempText == "Name") {
     return "componentName";
   } else if (tempText == "created By") {
     return "createdBy";
   } else if (tempText == "Description") {
     return "businessDescription";
   } else {
     return tempText;
   }
 }

  /**
   * 
   * @param filterResponse
   * @param data
   */
  conditionalDataFiltering(filterResponse: FilterResponseModel, data) {
    let temp;
    if (filterResponse.selectedCondition == "==") {
      temp = data.filter(
        function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue);
        });
    } else if (filterResponse.selectedCondition == ">=") {
      temp = data.filter((df) => df[filterResponse.selectedFieldName] >= parseInt(filterResponse.selectedValue, 10));
    } else if (filterResponse.selectedCondition == "<=") {
      temp = data.filter((df) => df[filterResponse.selectedFieldName] <= parseInt(filterResponse.selectedValue, 10));
    }
    return temp;
  }
}
